export enum SeverityEnum {
  CRITICAL = "CRITICAL",
  WARNING = "WARNING",
  MAJOR = "MAJOR",
  MINOR = "MINOR",
}
